import React from "react";
import './Full-Data.css';
import { Button, Heading, Columns, Table } from 'react-bulma-components';
import { db } from '../firestore';
import {doc, addDoc, setDoc, getDoc, getDocs, collection, query, where, GeoPoint, orderBy} from 'firebase/firestore'
import {BrowserRouter, HashRouter, Link} from "react-router-dom";
import { renderToString } from 'react-dom/server'

function FullDataBox() {

    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    if (readCookie("Username") !== null) {
        console.log("Reading cookie for User now.")
        console.log(readCookie("Username"))
    }

    // Fetching Names from Users in User
    const getNames = async () => {
        const querySnapshot = await getDocs(collection(db, "Users"))
        return querySnapshot.forEach((doc) => {

            if (doc.data()["TypeofUser"] === "NormalUser") {

                let table = document.getElementById('patients');
                let row = document.createElement('tr');
                let cell1 = row.insertCell();
                cell1.textContent = "3:00PM 10/10/2022"

                let cell2 = row.insertCell();
                cell2.textContent = doc.data()["HomeAddressText"]

                let uName = doc.data()["UserName"]
                let vName = uName[0].charAt(0).toUpperCase() + uName.slice(1);
                let cell3 = row.insertCell();
                cell3.textContent = vName

                let cell4 = row.insertCell();
                cell4.innerHTML = doc.data()["Phone"]

                table.appendChild(row);
            }
        });
    };

    getNames();

        return (
            <div className={"fullCardLayoutStyle"} style={{minHeight: "800px", height:"75vh"}}>
                <Link to="/hospital">
                <Button color="danger" size="small" style={{position: "absolute"}}>
                    <span>Go Back</span><br/>
                </Button>
                </Link>
                <Columns>
                    <Columns.Column>
                        <Heading className={"has-text-centered"}>
                            Database
                        </Heading>

                        <div className={"has-text-centered"}>
                            <Link to="/sensor">
                                <Button color="warning" size="medium">
                                    <span>View your Home Sensor Data</span><br/>
                                </Button>
                            </Link>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <Link to="/sensor">
                                <Button color="warning" size="medium">
                                    <span>View your Car Sensor Data</span><br/>
                                </Button>
                            </Link>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <Link to="/sensor">
                                <Button color="warning" size="medium">
                                    <span>View your Health Sensor Data</span><br/>
                                </Button>
                            </Link>
                        </div>
                    </Columns.Column>
                </Columns>
                <Columns>
                    <Columns.Column>
                        <Table size="fullwidth">
                            <thead>
                            <tr>
                                <th>Latest Update</th>
                                <th>Address</th>
                                <th>Name</th>
                                <th>Phone</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody id={"patients"}>

                            </tbody>
                        </Table>
                    </Columns.Column>
                </Columns>
            </div>
        );
}


export default FullDataBox;


// [[redirects]] from = "/*" to = "/" status = 200
